export const twitter_tweets = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9.562 7.576h-2.75V4.74a.678.678 0 00-.687-.687c-.43 0-.602.343-.602.687v2.836H2.687A.678.678 0 002 8.263c0 .43.258.688.687.688h2.836v2.835c0 .344.258.688.688.688.43 0 .687-.258.687-.688V8.865h2.836a.678.678 0 00.687-.688c0-.43-.43-.601-.86-.601zm12.38-4.493V3h-.082c-.082 0-7.525.994-11.779 9.693-3.108 6.295-2.944 8.2-2.699 8.2.245.084 2.781-5.384 5.48-7.62 4.254-.912 5.399-2.983 5.399-2.983s-1.227.166-1.718.166a4.178 4.178 0 01-1.39-.249c1.063-.994 1.963-1.242 2.862-1.408.736-.166 1.473-.331 2.454-.994 1.8-1.326 1.554-4.556 1.472-4.722z"
    fill="inherit"
  />
);
